export default {"src":"/_next/static/media/curved-items-landing-1.f9fd65c2.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};